













/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleSubheading"
	})
export default class ArticleHeading extends Vue {
	@Prop() private subheading: string;
	private changed(event: any) {
		this.$emit("update:subheading", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

}
